import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { withModel } from '../../../../view/data-providers/model';
import CheckoutHeader from './CheckoutHeader';

const enhance = compose(
  withModel,
  withRouter,
);

export default enhance(CheckoutHeader);
